import {MinusOutlined, PlusOutlined} from '@ant-design/icons'
import {Button, Form, Select} from 'antd'
import * as React from 'react'
import {useEffect, useState} from 'react'
import {CityBean, CountryBean, GeoBean, RegionBean} from 'src/api/api'
import dictionariesApi from 'src/util/DictionariesApi'
import {formDataLoader, FormDataType} from 'src/util/FormDataLoader'
import {clone} from '../../../util/Util'
import './style.css'

const Option = Select.Option
const FormItem = Form.Item

export interface GeoItem {
    country: string | undefined
    loadedRegions: RegionBean[]
    region: string | undefined
    loadedCities: CityBean[]
    city: string | undefined
}

interface Props {
    id
    loadGeo
    geoItems
    setGeoItems
}

export const toBean = (item: GeoItem): GeoBean => {
    return {
        country: item.country,
        region: item.region,
        city: item.city
    }
}

export const emptyGeoItem = () => {
    return {
        country: undefined,
        loadedRegions: [],
        region: undefined,
        loadedCities: [],
        city: undefined
    }
}

const formInfoItems: FormDataType[] = [
    FormDataType.Countries
]

const GeoTargeting = (props: Props) => {

    const [error, setError] = useState(undefined)
    const [info, setInfo] = useState({
        countries: []
    })

    const loadData = async () => {
        try {
            const resp = await formDataLoader(...formInfoItems)
            setInfo(resp as any)

            if (props.id) {
                const geo = await props.loadGeo(props.id)

                props.setGeoItems(geo.length == 0 ? [] : clone(geo))
            } else {
                props.geoItems.length == 1 && setSelectedCountry('HU', 0)
            }
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const setSelectedCountry = async (country: string, index: number) => {
        try {
            const resp = await dictionariesApi.regions(country)
            const cityResp = await dictionariesApi.citiesByCountry(country)

            const geoItem = props.geoItems[index]

            geoItem.country = country
            geoItem.loadedRegions = resp
            geoItem.loadedCities = cityResp
            geoItem.region = undefined
            geoItem.city = undefined

            const list = [...props.geoItems]
            props.setGeoItems(list)
        } catch (e) {
            setError(e.error)
        }
    }

    const clearSelectedCountry = (index: number) => {
        const geoItem = props.geoItems[index]
        geoItem.country = undefined
        geoItem.loadedRegions = []
        geoItem.region = undefined
        geoItem.loadedCities = []
        geoItem.city = undefined

        const list = [...props.geoItems]
        props.setGeoItems(list)
    }

    const setSelectedRegion = async (region: string, index: number) => {
        try {
            const resp = await dictionariesApi.cities(region)

            const geoItem = props.geoItems[index]
            geoItem.region = region
            geoItem.loadedCities = resp
            geoItem.city = undefined

            const list = [...props.geoItems]
            props.setGeoItems(list)
        } catch (e) {
            setError(e.error)
        }
    }

    const clearSelectedRegion = async (index: number) => {
        const geoItem = props.geoItems[index]
        geoItem.region = undefined
        geoItem.loadedCities = await dictionariesApi.citiesByCountry(geoItem.country)

        const list = [...props.geoItems]
        props.setGeoItems(list)
    }

    const setSelectedCity = (city: string, index: number) => {
        const geoItem = props.geoItems[index]
        geoItem.city = city

        const list = [...props.geoItems]
        props.setGeoItems(list)
    }

    const clearSelectedCity = (index: number) => {
        const geoItem = props.geoItems[index]
        geoItem.city = undefined

        const list = [...props.geoItems]
        props.setGeoItems(list)
    }

    const addRow = () => {
        const list = [...props.geoItems]
        list.push(emptyGeoItem())
        props.setGeoItems(list)
    }

    const removeRow = (index: number) => {
        const list = [...props.geoItems]
        list.splice(index, 1)
        props.setGeoItems(list)
    }

    const renderDayParting = () => (
        <div className="geo-items">
            {props.geoItems.length == 0 && <Button title="Add new country" onClick={addRow}><PlusOutlined /></Button>}
            <div>
                {props.geoItems.map((geo, index) => <div className="geo-item" key={index}>
                    <Select
                        showSearch
                        allowClear
                        optionFilterProp="title"
                        placeholder="Select country"
                        value={geo.country}
                        onSelect={value => setSelectedCountry(value, index)}
                        onClear={() => clearSelectedCountry(index)}
                        className="geo-selector ant-item-first"
                    >
                        {info.countries.map((item: CountryBean) => <Option title={item.name} key={item.code} value={item.code}>{item.name}</Option>)}
                    </Select>
                    <Select
                        showSearch
                        allowClear
                        optionFilterProp="title"
                        placeholder="Select region"
                        value={geo.region}
                        onSelect={value => setSelectedRegion(value, index)}
                        onClear={() => clearSelectedRegion(index)}
                        className="geo-selector ant-item-second"
                    >
                        {geo.loadedRegions.map((item: RegionBean) => <Option title={item.name} key={item.code} value={item.code}>{item.name}</Option>)}
                    </Select>
                    <Select
                        showSearch
                        allowClear
                        optionFilterProp="title"
                        placeholder="Select city"
                        value={geo.city}
                        onSelect={value => setSelectedCity(value, index)}
                        onClear={() => clearSelectedCity(index)}
                        className="geo-selector ant-item-second"
                    >
                        {geo.loadedCities.map((item: CityBean) => <Option title={item.name} key={item.id} value={item.id}>{item.name}</Option>)}
                    </Select>
                    <Button title="Remove country" className="ant-item-second" type="text" onClick={() => removeRow(index)}><MinusOutlined /></Button>
                    {index == props.geoItems.length - 1 && <Button title="Add new country" className="ant-item-second" type="text" onClick={addRow}><PlusOutlined /></Button>}
                </div>)}
            </div>
        </div>
    )

    return <FormItem label="Country list">
        {renderDayParting()}
    </FormItem>
}

export default GeoTargeting


// WEBPACK FOOTER //
// ./src/component/app/geo/GeoTargeting.tsx